import React from 'react';
import { MenuItem } from '@mui/material';
import { useSmartNavigate } from '../hooks/useSmartNavigate';
export function SmartMenuItem({ to, onBeforeNavigate, children, sx }) {
    const smartNavigate = useSmartNavigate();
    const handleClick = (event) => {
        onBeforeNavigate === null || onBeforeNavigate === void 0 ? void 0 : onBeforeNavigate();
        smartNavigate(to, event);
    };
    const handleAuxClick = (event) => {
        if (event.button === 1) {
            onBeforeNavigate === null || onBeforeNavigate === void 0 ? void 0 : onBeforeNavigate();
            smartNavigate(to, event);
        }
    };
    return React.createElement(MenuItem, { onClick: handleClick, onAuxClick: handleAuxClick, sx: sx }, children);
}
